<div class="div_loading">
  <div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>

<div class="table-navigation">
  <table class='list-table table table-hover table-bordered table-condensed table-responsive table-striped'
    [ngStyle]="lang == 2 && {direction:'ltr '}">
    <tr>
      <td style='text-align:right;direction:rtl !important' class="pe_navigation_number" colspan=10>
        <button (click)='open_detaile(0,1,0)' [disabled]='new_status' class="new1" *ngIf="lang == 1">جديد</button>
        <button (click)='open_detaile(0,1,0)' [disabled]='new_status' class="new1" *ngIf="lang == 2"
          [ngClass]="{en_navigation_number:lang==2}">New</button>

        <button (click)='open_detaile(0,3,0)' *ngIf="lang == 1" class="search1">جستجو</button>
        <button (click)='open_detaile(0,3,0)' *ngIf="lang == 2" [ngClass]="{en_navigation_number:lang==2}"
          class="search1">Search</button>
        <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
          <button [ngClass]="{en_navigation_number:lang==2}">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
          </button>
        </a>
        <button (click)="check_access(4,4,'',1,1)" [disabled]='next_status'><i class="fas fa-fast-forward"></i></button>
        <button (click)="check_access(4,2,'',1,1)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
        <button (click)="check_access(4,3,'',1,1)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        <button (click)="check_access(4,5,'',1,1)" [disabled]='pre_status'><i class="fas fa-fast-backward"></i></button>
        <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
          </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span> {{ count_total }} </span>
        </div>
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,0,1,2)"
          placeholder="جستجو..." autocomplete="off">
        <span class="window_title">{{ title }}</span>
      </td>
    </tr>
  </table>
</div>
<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
  style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
  <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
    [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}">

    <ng-container matColumnDef="row">
      <mat-header-cell *matHeaderCellDef style='max-width:70px'>
        <span *ngIf="lang == 1">ردیف</span>
        <span *ngIf="lang == 2">#</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>{{ i + page_number_first }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">عنوان تراکنش</span>
        <span *ngIf="lang == 2">Title</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
        x.sale_payment_title }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="customer">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">نام مشتری</span>
        <span *ngIf="lang == 2">---</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
        x.customer }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">شماره پیش فاکتور</span>
        <span *ngIf="lang == 2">---</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>
        {{ x.pre_factor_lsf_order_code_factor }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="price">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">مبلغ </span>
        <span *ngIf="lang == 2">---</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
        x.sale_payment_price | number }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="date3">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">تاریخ تراکنش</span>
        <span *ngIf="lang == 2">----</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
        x.sale_payment_date3 }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="creator">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">ثبت کننده</span>
        <span *ngIf="lang == 2">---</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{ x.creator }}
      </mat-cell>
    </ng-container>




    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1"> شناسه </span>
        <span *ngIf="lang == 2">Id</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{ x.sale_payment_id }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="operation">
      <mat-header-cell *matHeaderCellDef style='max-width:70px'>
        <span *ngIf="lang == 1"> عملیات </span>
        <span *ngIf="lang == 2">Operation</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>
        <span (click)='open_detaile(i,2,x.sale_payment_id)'><i class="fas fa-desktop icon"></i></span>
        <span (click)="check_access(3,'',x.sale_payment_id,'',1)"><i class="far fa-trash-alt icon"
            style='margin:0px 4px;'></i></span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
    <mat-row *matRowDef="let row;columns:displayedColumns;let i = index" (click)="mat_table_selectedRow = row"
      (mouseenter)="mat_table_hoverRow = row" (dblclick)="open_detaile(i,2,row.sale_payment_id)"
      [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,'mat_table_hover': row === mat_table_hoverRow}"
      class="cursor"></mat-row>

  </mat-table>

  <div class="row" class="preview1" [hidden]="count_total > 0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div>
        <img src="../../../../assets/images/preview.png">
      </div>
      <div class="preview2" *ngIf="lang == 1">هیچ رکوردی برای نمایش وجود ندارد</div>
      <div class="preview2" *ngIf="lang == 2">There are no records to display</div>
    </div>
  </div>

</div>